export enum NftSaleMarketplace {
  PeerToPeer = "initialised",
  MagicEden = "initializeOnMe",
  Solsea = "listedOnSolsea",
}
